export default __webpack_public_path__ + "static/media/bc-quote-icon.9813f21c.png";